module.exports = __webpack_public_path__ + "img/transportation.f70c105b.jpg";